<div class="body-app">
    <button class="buttonBack" (click)="goBack()" > <i class="material-icons buttonBack">navigate_before</i></button>

  <div class="login-body">
    <div class="login-logo-app">
      <img src="assets/images/logo-meep.png" alt="Meep">
    </div>
    <form>
        <app-input [inputModel]="forgetPasswordModel.cpfOuEmailInputModel" (isInputValid)="setFormStatus($event, 'cpfOuEmail')" [(value)]="forgetPasswordModel.CpfOuEmail"></app-input>
      <div class="button-row">
        <button mat-button class="buttonEnter" (click)="recoveryPassword()">Recuperar</button>
      </div>
    </form>
  </div>
</div>



// WEBPACK FOOTER //
// /usr/src/app/src/app/components/forget-password/forget-password.component.html